/**
 * Centralized authority string constants for claim roles.
 *
 * Every `ROLE_CLAIM_*` literal used across routes, menus, and config
 * should reference this file to avoid duplicate hard-coded strings
 * and reduce drift risk when authorities change.
 */

export const CLAIM_AUTHORITIES = {
  CLIENT_USER: 'ROLE_CLAIM_CLIENT_USER',
  RP_USER: 'ROLE_CLAIM_RP_USER',
  SAM_KAM: 'ROLE_CLAIM_SAM_KAM',
  GROUND_DEPS: 'ROLE_CLAIM_GROUND_DEPS',
  ZOOM_CLM: 'ROLE_CLAIM_ZOOM_CLM',
  CLM_RM: 'ROLE_CLAIM_CLM_RM',
  CLM: 'ROLE_CLAIM_CLM',
  HQ_DEPS: 'ROLE_CLAIM_HQ_DEPS',
  DESK: 'ROLE_CLAIM_DESK',
  HOD_DESK: 'ROLE_CLAIM_HOD_DESK',
  OPEX_HOD: 'ROLE_CLAIM_OPEX_HOD',
  OPS_HOD: 'ROLE_CLAIM_OPS_HOD',
  SALES_HOD: 'ROLE_CLAIM_SALES_HOD',
  FINANCE: 'ROLE_CLAIM_FINANCE',
  FINANCE_CN: 'ROLE_CLAIM_FINANCE_CN',
  FINANCE_FT: 'ROLE_CLAIM_FINANCE_FT'
};
